import { GameVars } from "./GameVars";
import { GameConstants } from "./GameConstants";
import { GameState } from "./states/GameState";
import { AchievementsManager } from "./AchievementsManager";
import { Card } from "./states/cards/Card";
import { FoundationPile } from "./states/cards/FoundationPile";
import { Board } from "./states/cards/Board";
import { OuterPile } from "./states/cards/OuterPile";

export class GameModel {

    public static currentInstance: GameModel;

    private cards: CardValue[];
    private index: number;
    private game: Phaser.Game;

    constructor(game: Phaser.Game) {

        GameModel.currentInstance = this;

        this.game = game;

        // clone and shuffle the cards array of GameVars
        this.cards = Phaser.ArrayUtils.shuffle(GameVars.getInstance().cards.slice());
        this.index = 0;

        GameVars.paused = false;
        GameVars.getInstance().shuffling = false;
        GameVars.getInstance().gameConcluded = false;
        GameVars.getInstance().originPileData = null;
        GameVars.getInstance().destinyPileData = null;

        if (GameVars.getInstance().retrieveSavedGame) {
            GameVars.getInstance().time = GameVars.getInstance().savedGameStateData.time;
            GameVars.getInstance().reshuffles = GameVars.getInstance().savedGameStateData.reshuffles;
            GameVars.getInstance().hints = GameVars.getInstance().savedGameStateData.hints;
        } else {
            GameVars.getInstance().time = GameConstants.TIME;
            GameVars.getInstance().reshuffles = 3;
            GameVars.getInstance().hints = 3;
        }
    }

    public loadRewardedAd(): void {

        if (gdsdk !== 'undefined' && gdsdk.preloadAd !== 'undefined') {
            gdsdk
                .preloadAd('rewarded')
                .then((response: any) => {
                    // A rewarded ad can be shown to user when he/she clicked it.
                })
                .catch((error: any) => {
                    // Any Rewarded ad is not available to user.
                });
        }
    }

    public destroy (): void {

        GameModel.currentInstance = null;
    }

    public initGameDistributionSDK(): void {

        window["GD_OPTIONS"] = {
            "gameId": "373148408c1647f3a68f558051d2f2f8",
            "onEvent": function(event: any): any {
                switch (event.name) {
                    case "SDK_GAME_START":
                        GameModel.currentInstance.game.paused = false;

                        if (GameVars.typeAd === "Resign") {
                            GameModel.currentInstance.onClickResign();
                        } else if (GameVars.typeAd === "Reshuffle") {
                            GameModel.currentInstance.onReshuffle();
                        } else if (GameVars.typeAd === "Hint") {
                            GameModel.currentInstance.onHint();
                        }
                        break;
                    case "SDK_GAME_PAUSE":
                        GameModel.currentInstance.game.paused = true;
                        break;
                    case "SDK_GDPR_TRACKING":
                        console.log("SDK_GDPR_TRACKING");
                        break;
                    case "SDK_GDPR_TARGETING":
                        console.log("SDK_GDPR_TARGETING");
                        break;
                    default:
                        break;
                }
            },
        };
        (function(d: any, s: any, id: any): any {
            var js: any, fjs: any = d.getElementsByTagName(s)[0];
            if (d.getElementById(id)) { return; }
            js = d.createElement(s);
            js.id = id;
            js.src = "https://html5.api.gamedistribution.com/main.min.js";
            fjs.parentNode.insertBefore(js, fjs);
        }(document, "script", "gamedistribution-jssdk"));
    }

    public getCardValue(): CardValue {

        var ret: CardValue = this.cards[this.index];

        this.index ++;

        return ret;
    }

    public onClickResign(): void {
        
        if ( GameConstants.SPONSOR === GameConstants.GAMEPIX) {
            GamePix.game.ping("game_over", {score : 0, level : 0, achievements : {/*put here if provided*/} });
        }

        GameVars.getInstance().simulatesStartedGame = false;

        GameState.currentInstance.onClickResign();
    }

    public onYesResign(): void {

        GameState.currentInstance.resign();
    }

    public onNoResign(): void {

        GameState.currentInstance.noResign();
    }

    public onClickHelp(): void {

        GameState.currentInstance.help();
    }

    public onOkHelp(): void {

        GameState.currentInstance.closeHelpMenu();
    }

    public onReshuffle(): boolean {

        if ( GameConstants.SPONSOR === GameConstants.GAMEPIX) {
            GamePix.game.ping("level_complete", {score : 0, level : 0, achievements : {/*put here if provided*/} });
        }

        GameVars.getInstance().reshuffles--;

        GameState.currentInstance.reshuffle();

        GameVars.getInstance().shuffling = true;

        this.game.time.events.add(1200, function(): void {
                GameVars.getInstance().shuffling = false;
        }, this);

        return true;
    }

    public onShufflingFinished(): void {

        GameVars.getInstance().shuffling = false;
    }

    public onHint(): boolean {
        
        if ( GameConstants.SPONSOR === GameConstants.GAMEPIX) {
            GamePix.game.ping("level_complete", {score : 0, level : 0, achievements : {/*put here if provided*/} });
        }

        GameVars.getInstance().hints--;

        var outerPileIndex: number = this.checkPiles();
        GameState.currentInstance.onHint(outerPileIndex);

        return true;
    }

    public onGameWon(): void {

        if (GameConstants.SPONSOR === GameConstants.MINIJUEGOS) {
            AchievementsManager.getInstance().onGameWon();
        }
        
        if ( GameConstants.SPONSOR === GameConstants.GAMEPIX) {
            GamePix.game.ping("level_complete", {score : 0, level : 0, achievements : {/*put here if provided*/} });
        }

        if (GameVars.getInstance().gameConcluded) {
            return;
        } else {
            GameVars.getInstance().gameConcluded = true;
        }

        GameVars.getInstance().simulatesStartedGame = false;
        
        var playTime: number = GameConstants.TIME - GameVars.getInstance().time;
        
        if (playTime < GameVars.getInstance().bestTime ) {
            GameVars.getInstance().bestTime = playTime;
        }

        GameState.currentInstance.gameWon();      
    }

    public onGameLost(): void {
        
        if ( GameConstants.SPONSOR === GameConstants.GAMEPIX) {
            GamePix.game.ping("game_over", {score : 0, level : 0, achievements : {/*put here if provided*/} });
        }

        if (GameVars.getInstance().gameConcluded) {
            return;
        } else {
            GameVars.getInstance().gameConcluded = true;
        }

        GameVars.getInstance().simulatesStartedGame = false;

        GameState.currentInstance.gameLost();
    }

    public showDevelopmentLayer(): void {

            GameVars.paused = true;
            GameState.currentInstance.showDevelopmentLayer();
    }

    public closeDevelopmentLayer(): void {

        GameVars.paused = false;
        GameState.currentInstance.closeDevelopmentLayer();
    }

    public onCardReleasedNowhere(card: Card): void {

        if (card.foundationPileIndex > -1) {

            var foundationPile: FoundationPile = Board.currentInstance.foundationPiles[card.foundationPileIndex - 1];
            foundationPile.addCard(card, false, true);

        } else {

            var outerPile: OuterPile = Board.currentInstance.outerPiles[card.outerPileIndex - 1];
            outerPile.addCard(card, false, true);
        }
        
        this.onCardNotMoved();
    }

    public onCardQuicklyReleased(card: Card): void {

        var valueCard: CardValue = card.cardValue;
        var valueUpperPileCard: CardValue;
        var foundationPile: FoundationPile;
        var addToPile: boolean = false;

        for (var i: number = 0; i < Board.currentInstance.foundationPiles.length; i ++) {

            foundationPile = Board.currentInstance.foundationPiles[i];

            valueUpperPileCard = foundationPile.getValueUpperCard();

            if (valueUpperPileCard !== null && valueCard.suit === valueUpperPileCard.suit) {

                if (foundationPile.kingsPile) {

                    if (this.isCardLower(valueUpperPileCard.value, valueCard.value)) {
                        addToPile = true;
                        break;
                    }

                } else {

                    if (this.isCardHigher(valueUpperPileCard.value, valueCard.value)) {
                        addToPile = true;
                        break;
                    }
                }
            }
        }

        if (addToPile) {
            
            this.onCardMoved(card, {i: foundationPile.i , isFoundation: true});

            foundationPile.addCard(card, false, true);

            if (!card.pointsGiven) {

                card.pointsGiven = true;

                this.onCardAddedToFoundationPile(foundationPile);
            }
            
        } else {

            // for the case it is a card already in the foundation piles
            if (card.foundationPileIndex > -1) {
                foundationPile = Board.currentInstance.foundationPiles[card.foundationPileIndex - 1];
                foundationPile.addCard(card);
            } else {
                var outerPile: OuterPile = Board.currentInstance.outerPiles[card.outerPileIndex - 1];
                outerPile.addCard(card);
            }
            
            this.onCardNotMoved();
        }
    }

    public onCardReleasedAboveOuterPile(card: Card, outerPileIndex: number): void {

        var addToPile: boolean = false;

        var outerPile: OuterPile = Board.currentInstance.outerPiles[outerPileIndex - 1];

        var valueUpperPileCard: CardValue = outerPile.getValueUpperCard();
        var valueCard: CardValue = card.cardValue;

        if (!valueUpperPileCard) {
            addToPile = true; // an empty outer pile, if true the card is added to the empty pile
        } else if (valueCard.suit === valueUpperPileCard.suit) {
            addToPile = this.canCardBePiledOnOuterPile(valueUpperPileCard.value, valueCard.value);
        }

        if (addToPile) {

            var foundationPile: FoundationPile;

            if (card.foundationPileIndex > -1) {
                foundationPile = Board.currentInstance.foundationPiles[card.foundationPileIndex - 1];
                this.onCardMoved(card, {i: foundationPile.i, isFoundation: true});
                foundationPile.addCard(card);
            } else {
                this.onCardMoved(card, {i: outerPile.i, isFoundation: false});
                outerPile.addCard(card);
            }

        } else {

            if (card.foundationPileIndex > -1) {

                foundationPile = Board.currentInstance.foundationPiles[card.foundationPileIndex - 1];
                foundationPile.addCard(card, false, true);

            } else {

                outerPile = Board.currentInstance.outerPiles[card.outerPileIndex - 1];
                outerPile.addCard(card, false, true);
            }
            
            this.onCardNotMoved();
        }
    }

    public onCardReleasedAboveFoundationPile(card: Card, foundationPileIndex: number): void {

        var addToPile: boolean = false;

        var foundationPile: FoundationPile = Board.currentInstance.foundationPiles[foundationPileIndex - 1];

        var valueUpperPileCard: CardValue = foundationPile.getValueUpperCard();
        var valueCard: CardValue = card.cardValue;

        if (valueUpperPileCard !== null && valueCard.suit === valueUpperPileCard.suit) {

            if (foundationPile.kingsPile) {

                if (this.isCardLower(valueUpperPileCard.value, valueCard.value)) {
                    addToPile = true;
                }

            } else if (this.isCardHigher(valueUpperPileCard.value, valueCard.value)) {
                addToPile = true;
            }
        }

        if (addToPile) {

            this.onCardMoved(card, {i: foundationPile.i, isFoundation: true});
            
            foundationPile.addCard(card);

            if (!card.pointsGiven) {

                card.pointsGiven = true;

                this.onCardAddedToFoundationPile(foundationPile);
            }

        } else {

            // for the case it is a card already in the foundation piles
            if (card.foundationPileIndex > -1) {
                foundationPile = Board.currentInstance.foundationPiles[card.foundationPileIndex - 1];
                foundationPile.addCard(card, false, true);
            } else {
                var outerPile: OuterPile = Board.currentInstance.outerPiles[card.outerPileIndex - 1];
                outerPile.addCard(card, false, true);
            }
            
            this.onCardNotMoved();
        }
    }

    public getCardsArraysForAnStartedGame(): any {

        var rnd: Phaser.RandomDataGenerator = new Phaser.RandomDataGenerator([Math.floor(Math.random() * 100)]);

        // foundation piles
        var foundationPiles: Object [][] = [];
        var outerCards: CardValue[] = [];

        var i: number;
        var j: number;
        var value: number;

        // las pilas de los ases
        for ( i = 0; i < 4; i++) {
            foundationPiles[i] = [];

            var suit: number = i;

                if (GameVars.getInstance().aboutToFinish) {
                value = rnd.integerInRange(11, 12);
                } else {
                value = rnd.integerInRange(3, 6);
                }

                for ( j = 1; j <= 13; j++) {

                if (j < value) {
                    foundationPiles[i].push ({value: this.convertValueToString(j), suit: suit});
                } else {
                    outerCards.push({value: this.convertValueToString(j), suit: suit});
                }
                }
        }

        // las pilas de los reyes
            for ( i = 4; i < 8; i++) {

            foundationPiles[i] = [];

            var suit: number = i - 4;

                if (GameVars.getInstance().aboutToFinish) {
                    value = rnd.integerInRange(1, 2);
                } else {
                    value = rnd.integerInRange(3, 6);
                }

                for ( j = 13; j > 0; j--) {

                    if (j > value) {
                        foundationPiles[i].push ({value: this.convertValueToString(j), suit: suit});
                    } else {
                        outerCards.push({value: this.convertValueToString(j), suit: suit});
                    }
                }
        }

        outerCards = Phaser.ArrayUtils.shuffle(outerCards);

        return [foundationPiles, outerCards];
    }

    public saveGameState(): void {

        var gameState: GameStateData = {    time: GameVars.getInstance().time,
                                            hints : GameVars.getInstance().hints,
                                            reshuffles: GameVars.getInstance().reshuffles,
                                            outerPiles: [],
                                            foundationPiles: []
                                        };

            var outerPiles: OuterPile[] = Board.currentInstance.outerPiles;
            var i: number;
            var j: number;

            for ( i = 0; i < outerPiles.length; i++) {

                gameState.outerPiles[i] = [];

                for ( j = 0; j < outerPiles[i].length; j++) {

                var card: Card = <Card> outerPiles[i].getChildAt(j);
                gameState.outerPiles[i].push(card.cardValue);
                }
            }

            // en principio se podrian deducir los valores de las foundation piles de las outer piles
            // ni tampoco hay que guardar todos la valores pero
            // es mas rapido hacerlo asi
            var foundationPiles: FoundationPile[] = Board.currentInstance.foundationPiles;

            for ( i = 0; i < foundationPiles.length; i++) {

                gameState.foundationPiles[i] = [];

                for ( j = 0; j < foundationPiles[i].length; j++) {

                var card: Card = <Card> foundationPiles[i].getChildAt(j);
                gameState.foundationPiles[i].push(card.cardValue);
                }
            }

            GameVars.getInstance().savedGameStateData = gameState;
    }

    public retrieveGameState(): void {

        GameVars.getInstance().retrieveSavedGame = true;

        GameState.currentInstance.retrieveGameState();
    }

    public onGameRetrieved(): void {

        GameVars.getInstance().retrieveSavedGame = false;
        GameVars.getInstance().savedGameStateData = null;
    }

    public undo(): void {
        
        if ( GameVars.getInstance().originPileData === null) {
            return;
        }
        
        GameState.currentInstance.undo();
    }

    private onCardMoved(card: Card, destinyPileData: PileData): void {

        if (card.outerPileIndex > -1) {
            GameVars.getInstance().originPileData = {i: card.outerPileIndex , isFoundation: false};
        } else {
            GameVars.getInstance().originPileData = {i: card.foundationPileIndex , isFoundation: true};
        }
        
        GameVars.getInstance().destinyPileData = destinyPileData;
        
        if ((GameVars.getInstance().originPileData.isFoundation && GameVars.getInstance().destinyPileData.isFoundation) && (GameVars.getInstance().originPileData.i === GameVars.getInstance().destinyPileData.i)) {
            this.onCardNotMoved();
        } else {
            // console.log("CARTA MOVIDA:", GameVars.getInstance().originPileData, GameVars.getInstance().destinyPileData);
            GameState.currentInstance.gui.activateUndoButton();
        } 
    }
    
    private onCardNotMoved(): void {
        
        GameVars.getInstance().originPileData = null;
        GameVars.getInstance().destinyPileData = null;
        
        GameState.currentInstance.gui.deactivateUndoButton(); 
        // console.log("CARTA NO MOVIDA:", GameVars.getInstance().originPileData, GameVars.getInstance().destinyPileData);
    }

    private isCardLower(aValue: string, bValue: string): boolean {

        return this.convertValueToInt(aValue) - this.convertValueToInt(bValue) === 1;
    }

    private isCardHigher(aValue: string, bValue: string): boolean {

        return this.convertValueToInt(aValue) - this.convertValueToInt(bValue) === -1;
    }

    private canCardBePiledOnOuterPile(aValue: string, bValue: string): boolean {

        var ret: boolean = false;

        if (this.convertValueToInt(aValue) - this.convertValueToInt(bValue) === 1) {
            ret = true;
        } else if (this.convertValueToInt(aValue) - this.convertValueToInt(bValue) === -1) {
            ret = true;
        } else if ( (aValue === "A" && bValue === "K") || (aValue === "K" && bValue === "A")) {
            ret = true;
        }

        return ret;
    }

    private convertValueToInt(value: string): number {

        var ret: number;

        switch (value) {
            case "A":
                ret = 1;
                break;
            case "K":
                ret = 13;
                break;
            case "Q":
                ret = 12;
                break;
            case "J":
                ret = 11;
                break;
                default:
                ret = parseInt(value);
        }

        return ret;
    }

        private convertValueToString(value: number): string {

        var ret: string;

        switch (value) {
            case 1:
                ret = "A";
                break;
            case 13:
                ret = "K";
                break;
            case 12:
                ret = "Q";
                break;
            case 11:
                ret = "J";
                break;
                default:
                ret = value.toString();
        }

        return ret;
    }

    private onCardAddedToFoundationPile(foundationPile: FoundationPile): void {

            var foundationPiles: FoundationPile[] = Board.currentInstance.foundationPiles;
            var foundationPilesCovered: number = 0;

            for (var i: number = 0; i < 8 ; i++) {

            if (foundationPiles[i].completed && !foundationPiles[i].covered) {
                    foundationPiles[i].coverPile();
                    
                    if (GameConstants.SPONSOR === GameConstants.MINIJUEGOS) {
                        AchievementsManager.getInstance().onPileCovered();
                    }
                    
                    this.onCardNotMoved();
            }

            if (foundationPiles[i].covered) {
                foundationPilesCovered++;
            }
            }

            if (foundationPilesCovered === 8) {
                this.onGameWon();
            }
    }

    private checkPiles(): number {

        // clonamos el array para que no siempre salga la opcion mas a la izquierda
        var outerPiles: OuterPile[] = Board.currentInstance.outerPiles.slice(0);
        outerPiles = Phaser.ArrayUtils.shuffle(outerPiles);

        var foundationPiles: FoundationPile[] = Board.currentInstance.foundationPiles;
        var cardValueA: CardValue;
        var cardValueB: CardValue;

        var isHintPossible: boolean = false;
        var hintOnOuterPile: boolean = false;
        var hintOnFoundationPile: boolean = false;

        for (var i: number = 0; i < outerPiles.length; i++) {

            cardValueB = outerPiles[i].getValueUpperCard();

            if (cardValueB) {

                // testear primero contra las foundations cards
                for (var k: number = 0 ; k < foundationPiles.length; k++) {

                    cardValueA = foundationPiles[k].getValueUpperCard();

                    if (cardValueA && cardValueA.suit === cardValueB.suit) {

                            if (foundationPiles[k].kingsPile) {

                            if (this.isCardLower(cardValueA.value, cardValueB.value)) {
                                isHintPossible = true;
                                hintOnFoundationPile = true;
                                break;
                            }

                        } else {

                            if (this.isCardHigher(cardValueA.value, cardValueB.value)) {
                                isHintPossible = true;
                                hintOnFoundationPile = true;
                                break;
                            }
                        }
                    }
                }

                if (isHintPossible) {
                    break;
                }

                for (var j: number = i + 1; j < outerPiles.length; j++) {

                    cardValueA = outerPiles[j].getValueUpperCard();

                    if (cardValueA && cardValueA.suit === cardValueB.suit) {
                        if (this.canCardBePiledOnOuterPile( cardValueA.value, cardValueB.value )) {
                            isHintPossible = true;
                            hintOnOuterPile = true;
                            break;
                        }
                    }
                }

                if (isHintPossible) {
                    break;
                }
            }
        }

        if ( isHintPossible) {

            return outerPiles[i].i - 1;

        } else {
            return -1;
        }
    }
}

